import type { AppMeta } from "@calcom/types/App";

import _package from "./package.json";

export const metadata = {
  name: "Slack",
  description: _package.description,
  installed: true,
  category: "messaging",
  categories: ["messaging"],
  logo: "icon.png",
  publisher: "Schedly, LLC",
  slug: "slack",
  title: "Slack",
  type: "slack_messaging",
  url: "https://slack.com",
  variant: "other",
  extendsFeature: "EventType",
  email: "info@schedly.io",
  dirName: "slack",
  isOAuth: true,
} as AppMeta;

export default metadata;
